import lodash from 'lodash';

export const binderSelector = state => lodash.get(state, 'binder');
export const unfiledDocumentsSelector = state => lodash.get(state, 'files.unfiledDocuments', []);
export const documentCountSelector = state => lodash.get(state, 'files.documentCount', null);
export const unfiledDocumentsCountSelector = state => lodash.get(state, 'binder.countUnfiledDocuments');
export const loadingDocumentsSelector = state => lodash.get(state, 'files.loadingDocuments', null);
export const loadingDocumentsErrorSelector = state => lodash.get(state, 'files.loadingDocumentsError', false);
export const onGoingDocumentConversionCountSelector = state => lodash.get(state, 'documentConversionStatuses.onGoingConversionCount', 0);
export const documentTypePermissionSelector = state => lodash.get(state, 'me.documentTypes', []);